
const translations = {
  // Navigation
  "nav.about": "À propos",
  "nav.business": "Activités",
  "nav.recruitment": "Recrutement",
  "nav.contact": "Contact",

  // Hero Section
  "hero.title1": "Matériaux textiles de haute qualité",
  "hero.title2": "Du Japon vers le monde",
  "hero.subtitle1": "Depuis 2006, qualité et confiance fiables",
  "hero.subtitle2": "Affaires directes avec les marques mondiales",
  "hero.cta": "Voir nos activités",

  // About Section
  "about.label": "À propos",
  "about.title": "Profil de l'entreprise",
  "about.description1": "SECOND CO., LTD a été fondée en 2006 en tant qu'entreprise spécialisée dans l'exportation de matières textiles. Depuis notre création, nous avons établi des relations de confiance avec nos clients étrangers grâce à la fourniture de produits et services de haute qualité.",
  "about.description2": "Nous nous concentrons sur les matières textiles et les produits de fil, travaillant avec nos clients sur la planification et le développement, réalisant 100% d'exportations à l'étranger. Notre force réside dans les relations directes avec les marques en Europe, notamment en Italie et en France.",
  "about.description3": "Nous avons établi un système d'approvisionnement stable et de haute qualité, avec une conformité totale en matière de traçabilité et de documentation qualité, garantissant à nos clients une utilisation en toute confiance.",
  "about.companyName": "Nom de l'entreprise",
  "about.companyNameValue": "SECOND CO., LTD",
  "about.englishName": "Nom anglais",
  "about.englishNameValue": "SECOND CO., LTD",
  "about.established": "Fondée",
  "about.establishedValue": "17 novembre 2006",
  "about.representative": "Représentant",
  "about.representativeValue": "PDG Hiromi Nonogaki",
  "about.capital": "Capital",
  "about.capitalValue": "8 millions de yens",
  "about.employees": "Employés",
  "about.employeesValue": "4",
  "about.address": "Adresse",
  "about.addressValue1": "2-7-14 Omiya, Ichinomiya,",
  "about.addressValue2": "Préfecture d'Aichi, Japon",
  "about.phone": "Téléphone",
  "about.phoneValue": "+81-586-25-4180",

  // Business Section
  "business.label": "Activités",
  "business.title": "Nos activités",
  "business.planning.title": "Planification et vente de matériaux",
  "business.planning.description": "De la planification à la vente de divers fils et matériaux, nous proposons des solutions adaptées aux besoins des clients. Nous sommes spécialisés dans la planification, la présentation et la vente de matières textiles sur le marché européen.",
  "business.export.title": "Opérations d'exportation",
  "business.export.description": "100% d'exportation à l'étranger, avec un système d'approvisionnement stable principalement vers l'Europe (Italie, France). Nous réalisons des affaires directes avec les marques.",
  "business.quality.title": "Contrôle qualité",
  "business.quality.description": "Conformité totale avec la traçabilité et la documentation qualité. Nous maintenons un système de contrôle qualité rigoureux pour livrer des produits de haute qualité en toute confiance.",

  // Recruitment Section
  "recruitment.label": "Recrutement",
  "recruitment.title": "Carrières",
  "recruitment.subtitle": "Rejoignez notre équipe",
  "recruitment.position": "Export et opérations commerciales",
  "recruitment.jobTitle": "Poste",
  "recruitment.jobTitleValue": "Opérations d'exportation, Administration commerciale",
  "recruitment.employmentType": "Type d'emploi",
  "recruitment.employmentTypeValue": "Temps plein ou temps partiel",
  "recruitment.workingHours": "Horaires de travail",
  "recruitment.workingHoursValue": "10h00 - 18h00",
  "recruitment.location": "Lieu",
  "recruitment.locationValue": "2-7-14 Omiya, Ichinomiya, Aichi, Japon",
  "recruitment.howToApply": "Comment postuler",
  "recruitment.howToApplyValue": "Veuillez nous contacter par email",
  "recruitment.atmosphere": "Environnement de travail",
  "recruitment.atmosphere1": "Un lieu de travail où de nombreuses femmes sont actives",
  "recruitment.atmosphere2": "Code vestimentaire flexible (tant que c'est soigné)",
  "recruitment.atmosphere3": "Horaires de travail détendus commençant à 10h00",

  // Contact Section
  "contact.label": "Contact",
  "contact.title": "Contactez-nous",
  "contact.company": "Nom de l'entreprise",
  "contact.name": "Votre nom",
  "contact.email": "Adresse email",
  "contact.message": "Message",
  "contact.submit": "Envoyer",
  "contact.submitting": "Envoi en cours...",
  "contact.success": "Merci pour votre demande. Nous avons bien reçu votre message.",
  "contact.error": "Échec de l'envoi. Veuillez réessayer.",
  "contact.characters": "caractères",

  // Footer
  "footer.companyInfo": "Informations",
  "footer.contact": "Contact",
  "footer.businessHours": "Heures d'ouverture",
  "footer.weekday": "Lun-Ven 10h00-18h00",
  "footer.holiday": "Fermé les week-ends et jours fériés",
  "footer.description": "SECOND CO., LTD\nLivrer des matières textiles\nde qualité au monde entier",
  "footer.copyright": "© 2006-2025 SECOND CO., LTD. Tous droits réservés."
};

export default translations;
